import React from 'react';
export function LiveBadge({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex items-center gap-2 px-2 py-1 rounded bg-red-500/10 border border-red-500/20 w-fit ${className}`} data-id="element-81">
      <div className="w-2 h-2 rounded-full bg-red-500 animate-pulse-fast shadow-[0_0_8px_rgba(239,68,68,0.8)]" data-id="element-82" />
      <span className="text-red-500 font-mono text-xs font-bold tracking-widest uppercase" data-id="element-83">
        Live
      </span>
    </div>;
}